import { useSelector } from 'react-redux';
import convertPointsToCash from './convertPointsToCash';
import convertCashToPoints from './convertCashToPoints';
import { getTiers } from 'store/pointsConversion/pointsConversionSelectors';

const usePointsConverters = () => {
  const conversionTiers = useSelector(getTiers);

  return {
    convertPointsToCash: ({ points }) => convertPointsToCash({ points, conversionTiers }),
    convertCashToPoints: ({ cash }) => convertCashToPoints({ cash, conversionTiers }),
  };
};

export default usePointsConverters;
